export default "__VITE_ASSET__DyPjMFRo__"